import request from '@/utils/request'
import qs from 'qs'
export function fetchList(params) {
  return request({
    url:'/order/list',
    method:'get',
    params:params
  })
}

export function fetchOptions() {
  return request({
    url:'/order/options',
    method:'get'
  })
}

export function orderRead(id) {
  return request({
    url:'/order/updateRead',
    method:'get',
    params:id
  })
}
export function getStaffInfo(id) {
  return request({
    url:'/order/getStaffInfo',
    method:'get',
    params:id
  })
}

export function getBoosterByGid(gid) {
  return request({
    url:'/order/getBoosterByGid',
    method:'get',
    params:gid
  })
}

export function changeBoosterRemark(id,boosterRemark) {
  return request({
    url:'/order/changeBoosterRemark',
    method:'get',
    params:id,boosterRemark
  })
}

export function createOrder(data) {
  return request({
    url:'/order/createOrder',
    method:'post',
    data:data
  })
}

export function updateOrder(data) {
  return request({
    url:'/order/updateOrder',
    method:'post',
    data:data
  })
}

export function changeOrderStatus(params) {
  return request({
    url:'/order/changeOrderStatus',
    method:'post',
    params:params
  })
}

export function addOperationNote(data) {
  return request({
    url:'/order/addOperationNote',
    method:'post',
    data:data
  })
}


export function changeOrderDelete(params) {
  return request({
    url:'/order/changeOrderDelete',
    method:'post',
    data:params
  })
}

export function changeBooster(params) {
  return request({
    url:'/order/changeBooster',
    method:'post',
    data:params
  })
}


export function getOrderDetail(id) {
  return request({
    url:'/order/'+id,
    method:'get'
  });
}


export function updateOrderNote(params) {
  return request({
    url:'/order/update/note',
    method:'post',
    params:params
  })
}

export function getPublicList(params) {
  return request({
    url:'/order/publicList',
    method:'get',
    params:params
  })
}

export function receiveOrders(data) {
  return request({
    url:'/order/receiveOrders',
    method:'post',
    data: data
  })
}

export function fetchMyOrders(params) {
  return request({
    url:'/order/fetchMyOrders',
    method:'get',
    params:params
  })
}

export function getMyOrderDetail(id) {
  return request({
    url:'/order/my/'+id,
    method:'get'
  });
}

export function getFlag() {
  return request({
    url:'/order/getFlag',
    method:'post'
  });
}

export function myGetBooster() {
  return request({
    url:'/order/myGetBooster',
    method:'post'
  });
}

export function getException() {
  return request({
    url:'/order/getException',
    method:'get'
  });
}

export function handleException(data) {
  return request({
    url:'/order/handleException',
    method:'post',
    data:data
  });
}
export function deleteOrder(data) {
  return request({
    url:'/order/deleteOrder',
    method:'post',
    data:data
  });
}



// WEBPACK FOOTER //
// ./src/api/order.js